<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
      v-on:save="saveHandler"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>

import thisForm from "../../../components/payroll/tp3/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": thisForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      pageTitle: this.$t('setuppersonpcbbfinformation.createnewstaffpcbtp3'),
      pageTitleValue: "",
      formData: {
        staffid: null,
        startdate: null,
        taxgross: null,
        // crcyid1: null,
        epfpaid: null,
        // crcyid2: null,
        pcbpaid: null,
        // crcyid3: null,
        rebate: null,
        // crcyid4: null,
        loectax: null,
        // crcyid5: null,
        stamp: 0,
        userid: this.$store.getters.userId,
      },

      // currency1List: [],
      // currency2List: [],
      // currency3List: [],
      // currency4List: [],
      // currency5List: [],
      staffList: [],
      staff1List: [],
      staff2List: [],
      // currencies: [],
      staffs: [],

      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    saveHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
        return false;
      }
      this.$store.dispatch('post', {url: "/tp3/create", payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = true;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "tp3list" });
          }
        })
        .catch((err) => {
          vm.isErr = true;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "tp3list" });
    },
  },
};
</script>